// extracted by mini-css-extract-plugin
export default {"soundsContainer":"Sounds_soundsContainer__Fuy9c","ul":"Sounds_ul__FcEc0"};